import { MouseEvent, RefObject, useCallback, useEffect } from 'react';

export const useClickOutside = (
  ref: RefObject<HTMLElement | null>,
  callback: (_e: MouseEvent) => void,
  skip?: boolean,
): void => {
  const handleClick = useCallback(
    (e: MouseEvent) => {
      if (skip) return;
      if (ref.current && !ref.current.contains(e.target as Node) && e.isTrusted) {
        callback(e);
      }
    },
    [callback, ref, skip],
  );

  useEffect(() => {
    document.addEventListener('mousedown', handleClick as unknown as EventListener);
    return () => {
      document.removeEventListener('mousedown', handleClick as unknown as EventListener);
    };
  }, [handleClick]);
};
